const Mixin = {
  data () {
    return {
      shipping: {
        location_address: null,
        location_city: null,
        location_postal_code: null,
        location_departament_id: null,
        location_municipality_id: null,
        location_country_id: null
      },
      billing: {
        location_address: null,
        location_neighborhood: null,
        location_postal_code: null,
        location_departament_id: null,
        location_municipality_id: null,
        location_country_id: null
      },
      checkout: {
        driver: null,
        signature: null,
        preference_id: null,
        init_point: null,
        sandbox_init_point: null,
        referenceCode: null,
        description: null,
        credentials: {
          merchantId: null,
          apiLogin: null,
          apiKey: null,
          accountId: null,
          notifyUrl: null,
          responseUrl: null,
          webCheckoutUrl: null
        },
        configuration: {
          CURRENCY: null,
          COUNTRY: null,
          LANGUAGE: null,
          IS_TEST: null,
          EXTERNAL: null,
          ALGORITHM_SIGNATURE: null,
          DISABLED_METHODS: null
        }
      }
    }
  },
  methods: {
    /*
    getUrlResponse () {
      const base = this.info.store_url
      const path = this.$router.resolve({ name: 'portal.index' }).href
      const url = base + path + 'online_payments/response'

      return url
    },
    */
    initPaymentCheckout () {
      if (this.checkout.driver === 'EPAYCO') this.payByEpayco()
      if (this.checkout.driver === 'MERCADOPAGO') this.payByMecadopago()
      if (this.checkout.driver === 'WOMPI') this.payByWompi()
      if (this.checkout.driver === 'EXTERNAL_TRANSFER') this.payByExternalTransfer()
    },
    payByEpayco () {
      this.statusLoading()

      window.location.assign(this.checkout.init_point) // check later Descomentarear Url de produccion
      // window.location.assign(this.checkout.sandbox_init_point) // check later Comentarear Solo para pruebas
    },
    payByMecadopago () {
      this.statusLoading()

      window.location.assign(this.checkout.init_point) // check later Descomentarear Url de produccion
      // window.location.assign(this.checkout.sandbox_init_point) // check later Comentarear Solo para pruebas
    },
    payByWompi () {
      this.statusLoading()

      window.location.assign(this.checkout.init_point)
    },
    payByExternalTransfer () {
      window.location.assign(this.$router.resolve({ name: 'portal.orders.complete' }).href) // , query: { po: this.order.id }
    }
  },
  created () {
  }
}

export default Mixin
